var _circle, _mask, _path, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpgrade = function SvgUpgrade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#FAF4FF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4442 37.2192L42.2221 17L24 37.2192H33.0166V47.9041H51.4276V37.2192H60.4442Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2221 17L43.7078 15.6611L42.2221 14.0126L40.7364 15.6611L42.2221 17ZM60.4442 37.2192V39.2192H64.9391L61.9299 35.8802L60.4442 37.2192ZM24 37.2192L22.5143 35.8802L19.5052 39.2192H24V37.2192ZM33.0166 37.2192H35.0166V35.2192H33.0166V37.2192ZM33.0166 47.9041H31.0166V49.9041H33.0166V47.9041ZM51.4276 47.9041V49.9041H53.4276V47.9041H51.4276ZM51.4276 37.2192V35.2192H49.4276V37.2192H51.4276ZM40.7364 18.3389L58.9586 38.5581L61.9299 35.8802L43.7078 15.6611L40.7364 18.3389ZM25.4857 38.5581L43.7078 18.3389L40.7364 15.6611L22.5143 35.8802L25.4857 38.5581ZM33.0166 35.2192H24V39.2192H33.0166V35.2192ZM35.0166 47.9041V37.2192H31.0166V47.9041H35.0166ZM51.4276 45.9041H33.0166V49.9041H51.4276V45.9041ZM49.4276 37.2192V47.9041H53.4276V37.2192H49.4276ZM60.4442 35.2192H51.4276V39.2192H60.4442V35.2192Z",
    fill: "#8546C2",
    mask: "url(#path-2-inside-1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0166,
    y: 52.1917,
    width: 16.411,
    height: 3.26027,
    stroke: "#8546C2",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0166,
    y: 60.7397,
    width: 16.411,
    height: 3.26027,
    stroke: "#8546C2",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpgrade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upgrade.c59cfbf5.svg";
export { ForwardRef as ReactComponent };